import { render, staticRenderFns } from "./LeaseSetupIndex.vue?vue&type=template&id=eb63b4ae"
import script from "./LeaseSetupIndex.vue?vue&type=script&lang=js"
export * from "./LeaseSetupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports